import { Info } from 'lucide-react'

export function LiveCampaignBanner() {
  return (
    <div className="flex items-start gap-2.5 rounded-lg border border-info/20 bg-info-bg p-3">
      <Info className="mt-0.5 size-4 shrink-0 text-info" />
      <div>
        <p className="text-xs font-medium text-info">This campaign is live.</p>
        <p className="mt-0.5 text-xs text-info/80">
          Changes will apply to future sends only. Contacts who have already
          received a step won&apos;t be affected.
        </p>
      </div>
    </div>
  )
}
